import { Record } from '@gonfalon/immutable-shim/immutableShim';
import { isNotEmpty, validateRecord } from '@gonfalon/legacy-form-validation/validationUtils';

import { createMember } from '#utils/members/records/Member';

export class OwnerInfo extends Record({
  promotedMember: createMember({}),
}) {
  validate() {
    return validateRecord(this, isNotEmpty('promotedMember'));
  }
}

export function createOwnerRecord(props = {}) {
  return new OwnerInfo(props);
}
